import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetChangeRequestStatusesAsync,
  IChangeRequestsGridFilterValueList,
} from "../../api/IChangeRequests";
import { RootState } from "../store";

export interface IChangeRequestsGridState {
  fetchStatus: string;
  changeRequestStatuses?: IChangeRequestsGridFilterValueList;
}

const initialState: IChangeRequestsGridState = {
  fetchStatus: "Loading...",
  changeRequestStatuses: undefined,
};

export const loadChangeRequestsOptionsAsync = createAsyncThunk(
  "chnageRequests/loadOptions",
  async () => {
    const recordStatuses = await GetChangeRequestStatusesAsync();
    // The value we return becomes the `fulfilled` action payload
    return {
      changeRequestStatuses: recordStatuses,
    };
  }
);

export const changeRequestsOptionsSlice = createSlice({
  name: "chnageRequestsOptions",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadChangeRequestsOptionsAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadChangeRequestsOptionsAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.changeRequestStatuses = action.payload.changeRequestStatuses;
      });
  },
});

export const selectChangeRequestsOptions = (state: RootState) =>
  state.changeRequestsOptions;

export default changeRequestsOptionsSlice.reducer;
